'use client'

import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import Heading from '@shared/components/Heading/Heading'
import { useSearchResults } from '@shared/components/Search/SearchProvider'
import { useState } from 'react'

export function PageTitle() {
  const results = useSearchResults()
  const name = results?.grouped_hits?.[0]?.hits[0].document.institution
  const [title] = useState(name?.[0])
  return <Heading h={1}>{title}</Heading>
}

export function BreadcrumbsWithCourt() {
  const results = useSearchResults()
  const name = results?.grouped_hits?.[0]?.hits[0].document.institution
  const [title] = useState(name?.[0] ?? '')

  return (
    <Breadcrumbs
      crumbs={[
        {
          title: 'Judikatur',
          href: '/judikatur',
        },
        {
          title,
        },
      ]}
    />
  )
}
